module.exports = __webpack_public_path__ + "img/cave60.35027220.jpg";